<template>
  <div style="height: 100%;">
    <v-card class="py-5 px-10" :style="`position: relative; height: 100%;`">
      <div>
        {{ item }}
      </div>

      <EventList
        v-if="item.type == 'list'"
      />
      <MapItem
        v-if="item.type == 'map'"
      />
      <v-icon
        style="position: absolute; top: 0; right: 0; cursor: pointer;"
        @click="$emit('delete')"
      >
        mdi-close
      </v-icon>
      <div
        style="position: absolute; top: 0; left: 5px;"
      >
        <v-icon
          v-tooltip="'Suodata'"
          @click="filtering = true"
          style="cursor: pointer;"
        >mdi-filter-variant</v-icon>
        <v-icon
          @click="settining = true"
          v-tooltip="'Asetukset'"
        >mdi-cog</v-icon>
      </div>
    </v-card>

    <CreateFilterDialog
      :show="filtering"
      :loading="false"
      :report="true"
      @close="filtering = false"
      @search="filterUpdated($event)"
    />
    <v-dialog max-width="800" v-model="settining">
      <v-card max-width="800">
        <EventListSettings
          v-if="item.type == 'list'"
        ></EventListSettings>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CreateFilterDialog from '@/components/filters/CreateFilterDialog.vue';
import EventList from '@/components/report/items/EventList.vue';
import MapItem from '@/components/report/items/MapItem.vue';
import EventListSettings from '@/components/report/items/EventListSettings.vue';
import { mapMutations } from 'vuex';

export default {
  props: ['item', 'season_id'],
  components: {
    CreateFilterDialog,
    EventList,
    MapItem,
    EventListSettings
  },
  data: () => ({
    filtering: false,
    settining: false,
    heights: [
      { value: 2, text: 'xs' },
      { value: 4, text: 'sm' },
      { value: 10, text: 'md' },
      { value: 15, text: 'lg' },
    ]
  }),
  methods: {
    ...mapMutations('report', ['UPDATE_ITEM']),
    filterUpdated(filter) {
      this.$emit('update', {
        ...this.item,
        filter
      })
      this.filtering = false;
    }
  }
}
</script>